import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import AddControl from 'components/add_control';
import BusinessInput from './input';

import type { Contact } from 'bundles/backoffice/contacts/types';
import type { FormContact } from 'bundles/backoffice/contacts/forms/types';

interface Props {
  allowSavingPrivateContacts?: boolean;
  contact: FormContact;
  multipleBusinesses?: boolean,
  onChange: (attributes: Partial<FormContact>) => void;
}

export default function ContactFormBusinessInputs({
  allowSavingPrivateContacts, contact, multipleBusinesses, onChange
}: Props) {
  const businesses = [...contact.businesses];

  if (businesses.length === 0) {
    businesses.push(null);
  }

  if (!multipleBusinesses) {
    businesses.splice(1);
  }

  function replaceBusiness(business: Contact | null, index: number) {
    const updatedBusinesses = [...contact.businesses];
    updatedBusinesses[index] = business;
    onChange({ businesses: updatedBusinesses });
  }

  function removeBusiness(index: number) {
    const updatedBusinesses = [...contact.businesses];
    updatedBusinesses.splice(index, 1);
    onChange({ businesses: updatedBusinesses });
  }

  return <>
    {businesses.map((business, i) => (
      <div className="d-flex align-items-center mb-3" key={i}>
        <div className="flex-1">
          <BusinessInput
            allowSavingPrivateContacts={allowSavingPrivateContacts}
            business={business}
            className="mb-0"
            contact={contact}
            onChange={business => replaceBusiness(business, i)}
          />
        </div>

        {businesses.length > 1 &&
          <FontAwesomeIcon
            className="ml-3"
            icon={faTrashAlt}
            onClick={() => removeBusiness(i)}
          />
        }
      </div>
    ))}

    {multipleBusinesses &&
      <AddControl onClick={() => replaceBusiness(null, businesses.length)}>
        Add another company
      </AddControl>
    }
  </>;
}
